import styled from 'styled-components';
import COLORS from 'constants/colors';

export const EventPillButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 5px 12px;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.15s ease;
  background: ${({ bg, isActive, hasVerdict }) =>
    isActive && !hasVerdict ? COLORS.WHITE : bg || COLORS.TRANSPARENT};
  border: ${({ isActive }) => (isActive ? '2px' : '1px')} solid;
  border-color: ${({ border, isActive, hasVerdict }) =>
    isActive && !hasVerdict ? COLORS.ABBEY : border || COLORS.GREY_2};

  &:hover {
    background: ${({ bg, hasVerdict }) => (hasVerdict ? bg : COLORS.WHITE)};
  }
`;
